// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94007faf","455":"b885ac0d","977":"e2893e4d"}[chunkId] + ".chunk.js";
};